module.exports = __webpack_public_path__ + "static/media/MetaMask_Fox.svg.c5d85ad4.png";